<template>
    <div class="spo-action-card pa-4 rounded" :class="[redBg ? 'bg-custom-red' : '']" @click="actionOnClick">

        <div class="d-flex flex-wrap align-center">
            <v-icon size="30" class="icon-action mr-2" :icon="icon"
                :color="disabled ? 'red-darken-4' : 'primary-dark'"></v-icon>
            <div class="d-flex flex-wrap align-center">
                <div class="spo-action-card-title font-weight-bold">
                    {{ title }}
                </div>
                <v-icon class="chevron-link mt-1" icon="mdi-chevron-right"></v-icon>
            </div>
        </div>
        <div :class="[disabled ? 'text-red-darken-4' : '']">{{ description }}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        toPage: {
            type: Object
        },
        toUrl: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        redBg: {
            type: Boolean,
            default: false
        }
    },
    name: 'ActionCard',
    methods: {
        actionOnClick() {
            if (this.disabled) {
                return;
            }
            if (this.toPage) {
                this.$router.push(this.toPage);
                return;
            }
            if (this.toUrl && this.toUrl !== '') {
                window.open(this.toUrl, '_blank');
                return;
            }
            this.$emit('onClick');
        }
    }
}
</script>

<style lang="scss" scoped></style>
